const IFRAME_ROUTE = {
    // key需要和json/menu.json数据对象里的route属性一致
    // key和json/menu.json数据对象里的route属性可根据需要自己定义

    // 报备子系统
    wybb: '../../static/html/report/wantReport/add.html', // 我要报备

    bblb: '../../static/html/report/reportList/list.html', //报备列表
    reportListDetail: '../../static/html/report/reportList/list.html',
    reportListEdit: '../../static/html/report/reportList/edit.html',
    reportListEditCorrect: '../../static/html/report/reportList/editCorrect.html',

    bcsmlb: '../../static/html/report/suppleList/list.html', //补充说明列表
    reportDetailBCSM: '../../static/html/report/suppleList/reportDetail.html',
    detailBCSM: '../../static/html/report/suppleList/detail.html',
    addBCSM: '../../static/html/report/suppleList/add.html',

    xzsclb: '../../static/html/report/assistant/list.html', //协助审查列表
    reportDetailAssistant: '../../static/html/report/assistant/reportDetail.html',
    detailAssistant: '../../static/html/report/assistant/detail.html',
    assistantXZSCLB: '../../static/html/report/assistant/assistant.html',

    sjtj: '../../static/html/report/statistic/index.html', //数据统计  
    lssjtj: '../../static/html/lssjtj/bb/index.html', //数据统计(历史数据)
    bbxtlssj: '../../static/html/lssj/bb/list.html', // 历史数据
    descriptionDetailsLSSJ_BB: '../../static/html/lssj/bb/detail.html',
    
    // 简化版报备系统
    wybbjhb: '../../static/html/reportSimple/wantReport/add.html', // 简化版-我要报备
    bblbjhb: '../../static/html/reportSimple/reportList/list.html', //简化版-报备列表
    reportListJhbDetail: '../../static/html/reportSimple/reportList/detail.html',
    reportListJhbEdit: '../../static/html/reportSimple/reportList/edit.html',
    reportListJhbEditCorrect: '../../static/html/reportSimple/reportList/editCorrect.html',

    balbCbr: '../../static/html/record/cbrRecordList/list.html', //承办人备案列表
    balbZhcx: '../../static/html/record/zhcxRecordList/list.html', //综合查询备案列表
    balbLd: '../../static/html/record/ldRecordList/list.html', //领导备案列表
    balbCsfzr: '../../static/html/record/csfzrRecordList/list.html', //处室负责人备案列表

    // 审查子系统
    sclb: '../../static/html/shencha/sclb.html',
    hslb: '../../static/html/shencha/hslb.html',
    zjtxyj: '../../static/html/shencha/zjtxyj.html',
    znfzsc: '../../static/html/shencha/znfzsc.html',
    bascyjs: '../../static/html/shencha/bascyjs.html',
    gglb: '../../static/html/shencha/gglb.html',
    xjgg: '../../static/html/shencha/xjgg.html',
    bjgg: '../../static/html/shencha/bjgg.html',
    batj: '../../static/html/shencha/batj.html',
    sctj: '../../static/html/shencha/sctj.html',
    sjzl: '../../static/html/shencha/sjzl.html',
    lsbatj: '../../static/html/lssjtj/ba/batj.html', // 备案统计(历史数据)
    lsbatj: '../../static/html/lssjtj/ba/batj.html', // 备案统计(历史数据)
    lssctj: '../../static/html/lssjtj/ba/sctj.html', // 审查统计(历史数据)
    scxtlssj: '../../static/html/lssj/ba/list.html', // 历史数据
    descriptionDetailsLSSJ_BA: '../../static/html/lssj/ba/detail.html',


    // 备案子系统
    balbCbr: '../../static/html/beian/cbrRecordList/list.html', //承办人备案列表
    balb: '../../static/html/beian/cbrRecordList/list.html',
    examine: '../../static/html/shencha/examine.html',  // 承办人审批页面 挪到了审查管理下
    examinescdzb: '../../static/html/shencha/examinescdzb.html',  // 承办人审查对照表下跳转审批页面
    examineDetail: '../../static/html/beian/cbrRecordList/examineDetail.html',
    checkDraft: '../../static/html/beian/cbrRecordList/checkDraft.html',
    fileDetail: '../../static/html/beian/cbrRecordList/fileDetail.html',
    descriptionDetailsPt2: '../../static/html/beian/cbrRecordList/descriptionDetailsPt.html',

    balbCsfzr: '../../static/html/beian/csfzrRecordList/list.html', //处室负责人备案列表
    examineCsfzr: '../../static/html/beian/csfzrRecordList/examine.html',
    examineCsfzrDetail: '../../static/html/beian/csfzrRecordList/examineDetail.html',
    descriptionDetailsPtCsfzr: '../../static/html/beian/csfzrRecordList/descriptionDetailsPt.html',

    balbLd: '../../static/html/beian/ldRecordList/list.html', //领导备案列表
    examineLd: '../../static/html/beian/ldRecordList/examine.html',
    examineLdDetail: '../../static/html/beian/ldRecordList/examineDetail.html',
    descriptionDetailsPtLd: '../../static/html/beian/ldRecordList/descriptionDetailsPt.html',

    balbZhcx: '../../static/html/beian/zhcxRecordList/list.html', //综合查询备案列表
    descriptionDetailsPt: '../../static/html/beian/zhcxRecordList/descriptionDetailsPt.html',

    // 专项评估
    // gdlbZXPG: '../../static/html/zxpg/ffgl/gdlb/list.html', // 归档列表
    // balbZXPG: '../../static/html/zxpg/ffgl/balb/cbrRecordList/list.html', // 备案列表
    // pglbZXPG: '../../static/html/zxpg/f1fgl/list.html', // 评估列表
    // hslbZXPG: '../../static/html/zxpg/ffgl/list.html', // 会审列表

    // 专项评估
    balbZXPGCbr: '../../static/html/zxpg/ffgl/balb/cbrRecordList/list.html', // 备案列表--承办人
    examineCbrZXPG: '../../static/html/zxpg/ffgl/balb/cbrRecordList/examine.html',
    checkDraftCbrZXPG: '../../static/html/zxpg/ffgl/balb/cbrRecordList/checkDraft.html',
    fileDetailCbrZXPG: '../../static/html/zxpg/ffgl/balb/cbrRecordList/fileDetail.html',
    descriptionDetailsPt2ZXPG: '../../static/html/zxpg/ffgl/gdlb/descriptionDetailsPt.html',
    descriptionDetailsPt2ZXPG2: '../../static/html/zxpg/ffgl/balb/cbrRecordList/descriptionDetailsPt.html',
    fileDetailZXPG: '../../static/html/zxpg/ffgl/gdlb/fileDetail.html',
    listZXPG: '../../static/html/zxpg/ffgl/balb/cbrRecordList/list.html',
    balbZXPGCsfzr: '../../static/html/zxpg/ffgl/balb/csfzrRecordList/list.html', // 备案列表--处室
    examineCsfzrZXPG: '../../static/html/zxpg/ffgl/balb/csfzrRecordList/examine.html',
    descriptionDetailsPtCsfzrZXPG: '../../static/html/zxpg/ffgl/balb/csfzrRecordList/descriptionDetailsPt.html',
    balbZXPGLd: '../../static/html/zxpg/ffgl/balb/ldRecordList/list.html', // 备案列表--领导
    descriptionDetailsPtLdZXPG: '../../static/html/zxpg/ffgl/balb/ldRecordList/descriptionDetailsPt.html',
    examineLdZXPG: '../../static/html/zxpg/ffgl/balb/ldRecordList/examine.html',
    gdlbZXPG: '../../static/html/zxpg/ffgl/gdlb/list.html', // 归档列表
    pglbZXPG: '../../static/html/zxpg/pggl/pglb/list.html', // 评估列表
    pgznfzscZXPG: '../../static/html/zxpg/pggl/pglb/pgznfzsc.html',
    pgzjtxyjZXPG: '../../static/html/zxpg/pggl/pglb/pgzjtxyj.html',
    hslbZXPG: '../../static/html/zxpg/pggl/hslb/list.html', // 会审列表
    xzscZXPG: '../../static/html/zxpg/bbyzxpg/assistant/list.html', // 协助审查
    reportDetailAssistantZXPG: '../../static/html/zxpg/bbyzxpg/assistant/reportDetail.html',
    assistantXZSCLBZXPG: '../../static/html/zxpg/bbyzxpg/assistant/assistant.html',
    detailAssistantZXPG: '../../static/html/zxpg/bbyzxpg/assistant/detail.html',
    bcsmZXPG: '../../static/html/zxpg/bbyzxpg/suppleList/list.html', // 补充说明
    reportDetailBCSMZXPG: '../../static/html/zxpg/bbyzxpg/suppleList/reportDetail.html',
    addBCSMZXPG: '../../static/html/zxpg/bbyzxpg/suppleList/add.html',
    detailBCSMZXPG: '../../static/html/zxpg/bbyzxpg/suppleList/detail.html',
};
export default IFRAME_ROUTE;
